export const LSTheme = 'LS-runcalc-theme';
export const LSLang = 'LS-runcalc-lang';